import { api } from './index.js';

const route = '/grid';

export const getGrid = async ({ project_uuid, model_uuid }) => {
	const { data } = await api.post(`${route}/get_grid`, {
		project_uuid,
		model_uuid,
	});
	return data;
};

export const getUnrotatedGrid = async projectId => {
	const { data } = await api.get(`/grid/${projectId}/unrotated_grid`);
	return data;
};

export const getRotatedGrid = async projectId => {
	const { data } = await api.get(`/grid/${projectId}/rotated_grid`);
	return data;
};

/**
 * Adds an annotation to the grid for a specific project, model and file
 *
 * @async
 * @param {Object} params - The parameters for adding an annotation.
 * @param {string} params.projectUuid - The UUID of the project.
 * @param {string} params.filename - The name of the file to add the annotation.
 * @param {string} params.classname - The class name for the annotation.
 * @param {string} params.classid - The class ID for the annotation.
 * @param {string} params.modelUuid - The UUID of the model.
 * @param {Array|Object} params.polygon - The normalized polygon data for the annotation.
 * @returns {Promise<Object>} The data returned from the API.
 */
export const addAnnotationToGrid = async ({
	projectUuid,
	filename,
	classname,
	classid,
	modelUuid,
	polygon,
}) => {
	const { data } = await api.post(`/grid/${projectUuid}/point_px`, {
		filename,
		classname,
		classid,
		model_uuid: modelUuid,
		polygon,
	});

	return data;
};

/**
 * Deletes an annotation from the grid for a specific project and model
 *
 * @async
 * @param {Object} params - The parameters for deleting an annotation
 * @param {string} params.projectUuid - UUID of the project
 * @param {string} params.modelUuid - UUID of the model
 * @param {string} params.annotationUuid - UUID of the annotation to be deleted
 * @returns {Promise<Object>} The data returned from the API.
 */
export const deleteAnnotationFromGrid = async ({ projectUuid, modelUuid, annotationUuid }) => {
	const { data } = await api.delete(`/grid/${projectUuid}/annotation`, {
		data: {
			model_uuid: modelUuid,
			annotation_uuid: annotationUuid,
		},
	});
	return data;
};
